import { createApi } from "@reduxjs/toolkit/query/react";
import { pyrotchBaseUrl, axiosBaseQuery } from "../axios/AxiosInstance";
import { PermissionsResponse , Permission} from "../../models/Permission";


export const PermissionsApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: pyrotchBaseUrl + "v1/",
  }),
  reducerPath: "PermissionsApi",
  tagTypes: ['Permissions'],
  endpoints: (build) => ({
    getPrivilegeData: build.query<PermissionsResponse, void>({
        query: () => {
          return {
            url: 'privilege',
            method: "GET",
          };
        },
      }),

      getPermissionsData: build.query<PermissionsResponse, void>({
        query: () => {
          return {
            url: 'privilege/permissions',
            method: "GET",
          };
        },
      }),

      getPermissions: build.query<Permission, { roleId: number}>({
        query: ({roleId}) => {
          return {
            url: `user/roles/permission?roleId=${roleId}`,
            method: "GET",
          };
        },
        providesTags: ['Permissions'],
      }),

      changePermissions: build.mutation<any, { roleId: number , permissions:string}>({
        query: ({roleId, permissions}) => {
          return {
            url: `user/roles/permission?roleId=${roleId}&permissions=${permissions}`,
            method: "POST",
          };
        },
        invalidatesTags: ['Permissions'],
      }),

      getRoles: build.query<PermissionsResponse, void>({
        query: () => {
          return {
            url: `user/roles/all`,
            method: "GET",
          };
        },
      }),
  }),

})



export const { useGetPrivilegeDataQuery , useGetPermissionsDataQuery , useGetPermissionsQuery , useChangePermissionsMutation , useGetRolesQuery} = PermissionsApi;